/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;

